import { Globe, Clock, XCircle, MinusCircle, ExternalLink } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

type PublicationStatus = 'not_published' | 'pending_review' | 'published' | 'rejected' | 'unpublished';

interface PublishedStatusBadgeProps {
  status: PublicationStatus;
  scoutaroundUrl?: string;
}

export function PublishedStatusBadge({ status, scoutaroundUrl }: PublishedStatusBadgeProps): JSX.Element {
  switch (status) {
    case 'published':
      return (
        <div className="flex items-center gap-2">
          <Badge variant="success" data-testid="published-badge">
            <Globe className="mr-1 h-3 w-3" />
            Published
          </Badge>
          {scoutaroundUrl && (
            <a
              href={scoutaroundUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="scoutaround-link"
            >
              <Button variant="outline" size="sm">
                <ExternalLink className="mr-2 h-4 w-4" />
                View on ScoutAround
              </Button>
            </a>
          )}
        </div>
      );

    case 'pending_review':
      return (
        <Badge variant="warning" data-testid="pending-review-badge">
          <Clock className="mr-1 h-3 w-3" />
          Pending Review
        </Badge>
      );

    case 'rejected':
      return (
        <Badge variant="destructive" data-testid="rejected-badge">
          <XCircle className="mr-1 h-3 w-3" />
          Rejected
        </Badge>
      );

    case 'unpublished':
      return (
        <Badge variant="outline" data-testid="unpublished-badge">
          <MinusCircle className="mr-1 h-3 w-3" />
          Unpublished
        </Badge>
      );

    case 'not_published':
    default:
      return (
        <Badge variant="secondary" data-testid="not-published-badge">
          <MinusCircle className="mr-1 h-3 w-3" />
          Not Published
        </Badge>
      );
  }
}
